import { FormControl } from 'react-bootstrap';
import styled from 'styled-components';

// For standalone hidden inputs (triggered by button click)
export const HiddenInput = styled(FormControl)`
  display: none;
`;

// For overlay inputs (covers entire parent area for click)
export const OverlayInput = styled(FormControl)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: block;
  opacity: 0;
  cursor: pointer;
`;
